import { Text } from '$components'
import { LinkButton } from '$components'

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center">
      <Text
        type="h1"
        className="font-semibold text-9xl mb-3 text-indigo-500"
      >
        404
      </Text>

      <Text
        type="h2"
        className="text-3xl mt-4"
      >
        Sorry! Page not found
      </Text>

      <Text
        type="p"
        className="max-w-lg mt-4 mb-8 font-light"
      >
        It looks like the page you&apos;re looking for doesn&apos;t exist or might have been moved. Let&apos;s get you back on track.
      </Text>

      <LinkButton
        size="lg"
        to="/"
      >
        Back to home
      </LinkButton>
    </div>
  )
}
